module.exports = __webpack_public_path__ + "static/media/print_frequencies.41ebd6cf.py";